<template>
	<AppLayout :title="trans('tools.academic-certificates.history.title')">
		<Pagination :resource="academicCertificates"/>
		<Empty v-if="academicCertificates.data.length === 0"/>
		<CardGrid v-else>
			<Card v-for="academicCertificate in academicCertificates.data" :key="`academic-certificates-${academicCertificate.id}`" :title="academicCertificate.user.full_name">
				<template #badges>
					<Badge v-if="academicCertificate.valid" :color="Color.Green" active>{{ trans('general.mark.accepted') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.mark.rejected') }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('tools.academic-certificates.created_at') }}</template>
					{{ dayjs(academicCertificate.created_at).format(trans('general.dayjs.date')) }}
				</LabeledObject>
				<LabeledObject v-if="academicCertificate.expires_at">
					<template #label>{{ trans('tools.academic-certificates.expires_at') }}</template>
					{{ dayjs(academicCertificate.expires_at).format(trans('general.dayjs.date')) }}
				</LabeledObject>
			</Card>
		</CardGrid>
		<Pagination :resource="academicCertificates"/>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import {type AcademicCertificate} from '@/Types/Tools/AcademicCertificate'

const props = defineProps<{
	academicCertificates:PaginatedModel<AcademicCertificate>,
}>()

const academicCertificates:Ref<PaginatedModel<AcademicCertificate>> = ref(props.academicCertificates)
</script>